module.exports = __webpack_public_path__ + "img/twitch.cd1d3408.svg";